import { JSX } from 'react';
import { RotateIcon } from '@bg-components/Icon';
import { ClassicGameDefinition, fullScreenStore, useMatchedGameId } from '@bg-shared';
import { useStore } from '@betgames/bg-state-manager';
import classNames from 'classnames';
import { useLandscape } from '@betgames/bg-tools';
import classes from './RotateRestriction.module.scss';

interface IProps {
    forced?: boolean;
}

export const RotateRestriction = (props: IProps): JSX.Element => {
    const isInFullscreen = useStore(fullScreenStore);
    const gameId = useMatchedGameId();
    const isLandscape = useLandscape();

    // disable restriction for slot games
    if (ClassicGameDefinition.isSlotGame(gameId)) {
        return null;
    }

    if (!isInFullscreen && !props.forced) {
        return null;
    }

    // To prevent component duplicate for games which use RotateRestriction not only in fullscreen mode
    if (isInFullscreen && props.forced) {
        return null;
    }

    return (
        <div
            className={classNames(classes.container, {
                [classes.show]: isLandscape,
            })}
            data-qa="area-rotate-screen"
        >
            <RotateIcon className={classes.icon} />
        </div>
    );
};
